export default "__VITE_ASSET__BxIvsuHP__"